export default "__VITE_ASSET___$63GzdK__"